import React, {useState, useEffect} from 'react'
import style from './index.module.scss'
import PropTypes from 'prop-types'
import { Label } from '../Label'
import { DropDown } from '../DropDown'
import { TooltipError } from '../TooltipError'
import { withStyles } from '@material-ui/core/styles';
import Tooltip from "@material-ui/core/Tooltip";
import VMasker from 'vanilla-masker'
import ApiSuno from '../../../api/services/ApiSuno';
import ApiSunoProvider from '../../../api/providers/ApiSuno';

export const Rentabilidade = (props) => {
    const apiSuno = new ApiSuno();
    const [value, setValue] = useState(setMask(props.valueText))
    const [tooltipValue, setTooltipValue] = useState(null)

    useEffect(() => {
        if(tooltipValue === null){
            getRentabilidade()
        }
        props.onChangeText(value)
    }, [value])

    function getRentabilidade(){
        apiSuno.getIpca(
        responseSuccess=>{
            try {
                if(responseSuccess.yearly.length > 0){
                    setTooltipValue(responseSuccess.yearly[0].value.toFixed(2).replace('.',','))
                }
            } catch (error) {
                console.log("++++++++++++++++++")
                console.log(error)
                console.log("++++++++++++++++++")
            }
        },
        responseError=>{
            console.log("++++++++++++++++++")
            console.log(responseError)
            console.log("++++++++++++++++++")
  
        })
    }

    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
          backgroundColor: '#D42126',
          fontSize: theme.typography.pxToRem(12),
          border: '1px solid #D42126',
        },
        arrow: {
            color: '#D42126',
            left: '10px!important'
        },
    }))(Tooltip);
    
    const handleTextChange = (value) => {
        let v = value.target.value
        v = setMask(v)
        setValue(v)
    }

    const droplist = (window.screen.width <= 768)?[
        {id:1, label:'a.m.'},
        {id:12, label:'a.a.'}
    ]
    :[
        {id:1, label:'ao mês'},
        {id:12, label:'ao ano'}
    ]

    function setMask(value){
        return VMasker.toMoney(value, {
            precision: 2,
            separator: ',',
            delimiter: '.'
        })
    }
    function getDefaultValue(){
        return droplist.find(e => e.id === parseInt(props.valueSelect))
    }

    return (
        <div className={style.main}>
            <Label tooltip={true} tooltipText={`Sugestão de rentabilidade: <br />CDI (${tooltipValue}% a.a.)`}>{props.label}</Label>
            <div className={style.valueInput}>
                <div className={style.inputfield}>
                    <input 
                        className={style.textinput} 
                        onChange={handleTextChange}
                        value={props.valueText}
                        type="tel"
                        />
                        <span className={style.sifrao}>%</span>
                </div>
                <div className={style.dropDown}>
                    <DropDown 
                        list={droplist}
                        selected={getDefaultValue()}
                        onChange={props.onChangeSelect}
                    />
                </div>
            </div>
            {(props.valid)?
                null
            :<TooltipError text="Preencha esse campo"/>}
        </div>
    )
}

Rentabilidade.propTypes = {
    valueText: PropTypes.any,
    onChangeText: PropTypes.func
}